export enum JDAReportsSector {
  'break-bulk' = "Break Bulk",
  bulk = "Bulk",
  container = "Container",
  maintenance = "Maintenance",
  'modified-duty' = "Modified Duty",
  other = "Other",
}
